/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountEmailSetting {
    getFixupPrototypeFunction() { return MasterAccountEmailSetting.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountEmailSetting>): MasterAccountEmailSetting {
        let obj = Object.assign(new MasterAccountEmailSetting(), model);
        MasterAccountEmailSetting.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountEmailSetting>): MasterAccountEmailSetting {
        if (!model) return null;
        return MasterAccountEmailSetting.newInstance(<MasterAccountEmailSetting> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountEmailSetting) {
        if (!obj) return;

        models.MasterAccountEmailSetting.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountEmailSetting): boolean {
        Object.setPrototypeOf(obj, MasterAccountEmailSetting.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.smtp_port === undefined) {
            this.smtp_port = 0;
        }
    }

    /**
     * SMTP
     */
    smtp: string;

    /**
     * Smtp port no
     */
    smtp_port: number;

    /**
     * User name
     */
    username: string;

    /**
     * Email
     */
    email: string;

    /**
     * Password for email
     */
    password: string;

    /**
     * Enable Starttls
     */
    enable_starttls: boolean;

}
